<header *ngIf="!desktopView" [ngClass]="{ 'full-height': isActiveSearch }" class="header px-2 pt-1"
  style="overflow-y: unset !important">
  <div class="d-flex justify-content-space-between mb-3">
    <div class="d-inline-flex">
      <a #logoLink class="w-full md:mx-auto" routerLink="/">
        <img *ngIf="!scConf" alt="Logo" class="logo" src="{{ baseUrl + logo }}" />
        <img *ngIf="scConf" alt="Logo" class="logo" [src]="yallaHeaderLogo" />
      </a>
    </div>
    <div class="d-inline-flex icon-deliver">
      <svg height="16" id="a559119926c5ebd4e4ff6e365c5da3c1" viewBox="0 0 15.999 16" width="15.999"
        xmlns="http://www.w3.org/2000/svg">
        <g data-name="Group 1082" id="Group_1082">
          <path d="M0,0H16V16H0Z" data-name="Path 9826" fill="none" id="Path_9826" />
          <path d="M0,0H16V16H0Z" data-name="Path 9827" fill="none" id="Path_9827" />
        </g>
        <g data-name="Group 1083" id="Group_1083" transform="translate(1.678 0.668)">
          <path
            d="M10.334,12.335a.667.667,0,0,1-.607-.391C9.272,10.944,7,5.875,7,4.335a3.333,3.333,0,1,1,6.666,0c0,1.54-2.271,6.609-2.727,7.609a.663.663,0,0,1-.607.391Zm0-10a2,2,0,0,0-2,2,27.475,27.475,0,0,0,2,5.684,27.461,27.461,0,0,0,2-5.684A2,2,0,0,0,10.334,2.335Z"
            data-name="Path 9828" fill="#fff" id="Path_9828" transform="translate(-4.012 -1.002)" />
          <circle cx="1.153" cy="1.153" data-name="Ellipse 15" fill="#fff" id="Ellipse_15" r="1.153"
            transform="translate(5.096 2.407)" />
          <path
            d="M13.829,18H3.851a1.333,1.333,0,0,1-1.225-1.859l1.428-3.332A1.33,1.33,0,0,1,5.28,12h.549v1.333H5.28L3.851,16.669h9.978L12.4,13.336h-.571V12H12.4a1.33,1.33,0,0,1,1.225.809l1.428,3.333A1.333,1.333,0,0,1,13.829,18Z"
            data-name="Path 9829" fill="#fff" id="Path_9829" transform="translate(-2.517 -4.669)" />
        </g>
      </svg>
      <div (click)="!isShowYello && showDialog = true"
        [ngClass]="{ 'pointer-events-none': selectedTenant?.tenantId === '3' }" class="delivery"
        style="font-family: var(--regular-font)">
        <span class="deliver-to">{{ "header.deliverTo" | translate }}</span>

        <span class="deliver-color" [ngClass]="{'small-text': selectedTenant?.tenantId==4}">
          {{ selectedTenant?.name }} <em class="fa fa-angle-down ml-3"></em></span>
      </div>
    </div>
    <div *ngIf="isShowYello" class="d-inline-flex">
      <a class="sell-yalla ng-star-inserted" [href]="merchantURL" target="_blank">
        <div class="sell-on-yalla cursor-pointer">
          <span class="sell-on-yalla-logo"> </span> Sell on<br />Yalla Mall
        </div>
      </a>
    </div>
  </div>
  <div class="d-flex justify-content-space-between mb-3 signin-margin">
    <div class="d-inline-flex">
      <select #langSelect (change)="changeLang(langSelect.value)" [disabled]="true" class="select-language"
        id="language" name="language">
        <option *ngFor="let language of languages" [selected]="language.code === selectedLanguage"
          [value]="language.code">
          {{ language.name }}
        </option>
      </select>
    </div>
    <div class="d-inline-flex">
      <a [routerLink]="'/wishlist'" class="cart_route wishlist-top">
        <span [ngClass]="{ 'margin-top7 ': authToken, 'margin-top10': !authToken }" class="mx-3 cursor-pointer"
          style="display: flex">
          <em>
            <img alt="No Image" src="assets/icons/heart-empty.svg" />
          </em>
          <span class="ml-1" style="font-family: var(--regular-font)">
            {{ "header.wishList" | translate }}
          </span>
        </span>
      </a>
    </div>
    <div class="d-inline-flex">
      <a class="cart_route cart-top" routerLink="/cart">
        <span class="mx-3 cursor-pointer" style="
            font-family: var(--regular-font);
            display: flex;
            align-items: flex-end;
            position: relative;
          ">
          <img alt="No Image" [ngClass]="{
              'margin-top3 ': authToken,
              'margin-top9': !authToken
            }" class="sign-in-logo mr-1" src="assets/images/header/icon1.svg" />
          <p-badge class="badge-mobile" value="{{ cartListCount }}"></p-badge>
          {{ "header.cart" | translate }}
        </span>
      </a>
    </div>
    <div class="d-inline-flex">
      <ng-container *ngIf="!authToken">
        <a class="actions sign-in-a" routerLink="/login">
          <img alt="No Image" class="login-icon" src="assets/images/header/icon2.svg" style="margin-right: 10px" />

          <div style="font-size: 12px; font-family: var(--regular-font)">
            <div *ngIf="!isShowYello">Y'ello,<br /></div>
            <div class="signin-text">
              {{ "header.signIn" | translate }}
            </div>
          </div>
        </a>
      </ng-container>
      <ng-container *ngIf="authToken">
        <div class="actions" style="display: inline-flex; align-items: center">
          <p-overlayPanel #op [appendTo]="'body'">
            <ng-template pTemplate>
              <div class="profile-menu">
                <div (click)="op.hide()" class="my-2">
                  <a class="cursor-pointer no-underline main-color font-size-15px regular-font" routerLink="/orders">{{
                    "header.yourOrders" | translate }}</a>
                </div>
                <div (click)="op.hide()" class="my-2">
                  <a class="cursor-pointer no-underline main-color font-size-15px regular-font"
                    routerLink="/account/address">{{ "header.yourAddresses" | translate }}</a>
                </div>
                <div (click)="op.hide()" class="my-2">
                  <a class="cursor-pointer no-underline main-color font-size-15px regular-font" routerLink="/account">{{
                    "header.yourDetails" | translate }}</a>
                </div>
                <div (click)="op.hide()" class="my-2">
                  <a (click)="logOut()" class="cursor-pointer no-underline main-color font-size-15px regular-font">{{
                    "header.logout" | translate }}</a>
                </div>
              </div>
            </ng-template>
          </p-overlayPanel>
          <span (click)="op.toggle($event)" class="cursor-pointer" style="display: flex">
            <em class="pi pi-user mobile-header-color"> </em>
            <span class="flex-nowrap overflow-hidden text-overflow-ellipsis w-8rem mobile-header-color"
              title="{{ Name }}">
              {{ "header.hi" | translate }}
              {{ Name.length <= 4 ? Name : (Name | slice : 0 : 3) }} {{ Name.length> 4 ? ".." : "" }}
            </span>
          </span>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="d-flex bg-main-color">
    <div class="d-inline-flex">
      <app-navbar class="w-full"></app-navbar>
    </div>
    <div class="d-contents">
      <app-search (onResult)="isActiveSearch = $event" class="w-full"></app-search>
    </div>
  </div>
</header>

<div class="v3-header">
  <header *ngIf="desktopView" class="d-flex justify-content-space-between">
    <div class="d-inline-flex">
      <img *ngIf="!scConf" alt="Logo" class="d-flex header-logo align-items-center justify-content-center"
        routerLink="/" src="{{ baseUrl + logo }}" />
      <img *ngIf="scConf" alt="Logo" class="d-flex header-logo align-items-center justify-content-center" routerLink="/"
        [src]="yallaHeaderLogo" />
    </div>

    <div class="select-location">
      <svg height="16" id="a559119926c5ebd4e4ff6e365c5da3c1" viewBox="0 0 15.999 16" width="15.999"
        xmlns="http://www.w3.org/2000/svg">
        <g data-name="Group 1082" id="Group_1082">
          <path d="M0,0H16V16H0Z" data-name="Path 9826" fill="none" id="Path_9826" />
          <path d="M0,0H16V16H0Z" data-name="Path 9827" fill="none" id="Path_9827" />
        </g>
        <g data-name="Group 1083" id="Group_1083" transform="translate(1.678 0.668)">
          <path
            d="M10.334,12.335a.667.667,0,0,1-.607-.391C9.272,10.944,7,5.875,7,4.335a3.333,3.333,0,1,1,6.666,0c0,1.54-2.271,6.609-2.727,7.609a.663.663,0,0,1-.607.391Zm0-10a2,2,0,0,0-2,2,27.475,27.475,0,0,0,2,5.684,27.461,27.461,0,0,0,2-5.684A2,2,0,0,0,10.334,2.335Z"
            data-name="Path 9828" fill="#fff" id="Path_9828" transform="translate(-4.012 -1.002)" />
          <circle cx="1.153" cy="1.153" data-name="Ellipse 15" fill="#fff" id="Ellipse_15" r="1.153"
            transform="translate(5.096 2.407)" />
          <path
            d="M13.829,18H3.851a1.333,1.333,0,0,1-1.225-1.859l1.428-3.332A1.33,1.33,0,0,1,5.28,12h.549v1.333H5.28L3.851,16.669h9.978L12.4,13.336h-.571V12H12.4a1.33,1.33,0,0,1,1.225.809l1.428,3.333A1.333,1.333,0,0,1,13.829,18Z"
            data-name="Path 9829" fill="#fff" id="Path_9829" transform="translate(-2.517 -4.669)" />
        </g>
      </svg>
      <div (click)=" showDialog = true" [ngClass]="{ 'pointer-events-none': selectedTenant?.tenantId === '3' }"
        class="delivery cursor-pointer">
        <span>{{ "header.deliverTo" | translate }} </span>

        <span>
          {{ selectedTenant?.name }} <em class="fa fa-angle-down ml-3"></em></span>
      </div>
    </div>

    <div class="d-inline-flex w-100 search-bar">
      <app-search (onResult)="isActiveSearch = $event"
        class="d-flex w-100 align-items-center justify-content-center"></app-search>
    </div>

    <!-- <div class="d-inline-flex language-dropdown">
      <select
        #langSelect
        (change)="changeLang(langSelect.value)"
        [disabled]="true"
        id="language-dropdown"
        name="language"
      >
        <option
          *ngFor="let language of languages"
          [selected]="language.code === selectedLanguage"
          [value]="language.code"
        >
          {{ language.name === "French" ? "Français" : language.name }}
        </option>
      </select>
    </div> -->

    <div *ngIf="!authToken" class="d-inline-flex unauth-signin ml-2">
      <a class="d-flex flex-row align-items-center justify-content-center" routerLink="/login">
        <em class="pi pi-user align-items-center justify-content-center"></em>

        <div>
          <div *ngIf="!isShowYello">Y'ello,<br /></div>
          <div>
            {{ "header.signIn" | translate }}
          </div>
        </div>
      </a>
    </div>
    <ng-container *ngIf="authToken">
      <div class="actions d-inline-flex">
        <p-overlayPanel #op [appendTo]="'body'">
          <ng-template pTemplate>
            <div class="profile-menu">
              <div (click)="op.hide()" class="my-2 profile-menu-item">
                <a class="cursor-pointer no-underline main-color font-size-15px regular-font" routerLink="/orders">{{
                  "header.yourOrders" | translate }}</a>
              </div>
              <div (click)="op.hide()" class="my-2 profile-menu-item">
                <a class="cursor-pointer no-underline main-color font-size-15px regular-font"
                  routerLink="/account/address">{{ "header.yourAddresses" | translate }}</a>
              </div>
              <div (click)="op.hide()" class="my-2 profile-menu-item">
                <a class="cursor-pointer no-underline main-color font-size-15px regular-font" routerLink="/account">{{
                  "header.yourDetails" | translate }}</a>
              </div>
              <div (click)="op.hide()" class="my-2 profile-menu-item">
                <a (click)="logOut()"
                  class="cursor-pointer no-underline main-color font-size-15px regular-font logout-user">{{
                  "header.logout" | translate }}</a>
              </div>
            </div>
          </ng-template>
        </p-overlayPanel>
        <span (mouseenter)="op.toggle($event)"
          class="cursor-pointer d-flex mx-3 cursor-pointer align-items-center justify-content-center user-name"
          id="profile">
          <em class="pi pi-user pi-white"></em>
          <span class="ml-2 d-inline-flex flex-nowrap ml-2 overflow-hidden text-overflow-ellipsis w-6rem"
            style="white-space: nowrap">
            {{ "header.hi" | translate }}
            {{ Name | slice : 0 : 6 }}
            {{ Name.length > 6 ? "..." : "" }}
          </span>
        </span>
      </div>
    </ng-container>

    <div class="d-inline-flex wishlist-icon">
      <a [routerLink]="'/wishlist'" class="d-flex mx-3 cursor-pointer align-items-center justify-content-center">
        <img alt="No Image" src="assets/icons/heart-empty.svg" />
        <span class="ml-1">
          {{ "header.wishList" | translate }}
        </span>
      </a>
    </div>

    <div class="d-inline-flex cart-icon">
      <a class="d-flex mx-3 cursor-pointer align-items-center justify-content-center" routerLink="/cart">
        <span class="mx-3 cursor-pointer" style="position: relative">
          <img alt="No Image" class="mr-1" src="assets/images/header/icon1.svg" />
          <p-badge class="badge-mobile" value="{{ cartListCount }}"></p-badge>
          {{ "header.cart" | translate }}
        </span>
      </a>
    </div>




    <div *ngIf="isShowYello" class="d-inline-flex">
      <a class="sell-yalla ng-star-inserted" [href]="merchantURL" target="_blank">
        <div class="sell-on-yalla cursor-pointer">
          <span class="sell-on-yalla-logo"> </span> Sell on<br />Yalla Mall
        </div>
      </a>
    </div>
    <div *ngIf="screenWidth > 768 && true" class="v3-header-cateogries">
      <div class="header-category">
        <div class="col-12 px-0 pb-0 header-mtn">
          <div class="flex flex-row">
            <app-navbar class="category-navbar w-100"></app-navbar>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>

<p-dialog [(visible)]="showDialog" [breakpoints]="{ '960px': '75vw', '640px': '90vw' }" [dismissableMask]="true"
  [draggable]="false" [modal]="true" [resizable]="false" [showHeader]="false" class="confirmation-modal">
  <ng-template pTemplate="content">
    <div class="content">
      <img style="width: 130px;" alt="No Image" alt="Logo" class="mb-3" src="assets/images/logo-marketplace.png" />
      <h2 class="mb-1 select-country">Select country</h2>
      <p class="country-desp mb-3">
        Click on your country name to enter Yalla Super Mall
      </p>

      <div class="product-search p-inputgroup mb-3">
        <span class="p-inputgroup-addon color"><em class="pi pi-search"></em></span>
        <form autocomplete="off" class="ng-untouched ng-pristine ng-valid" novalidate="" style="display: contents">
          <input (input)="searchCountries($event)" [(ngModel)]="country" [ngModelOptions]="{ standalone: true }"
            autocapitalize="off" autocomplete="new-password" autocorrect="off"
            class="p-inputtext p-component p-element ng-untouched ng-pristine ng-valid" pinputtext=""
            placeholder="Search country" spellcheck="false" type="text" />
        </form>
      </div>
      <div *ngIf="countriesList?.length === 0" class="col-12 text-center">
        <p class="no-found">No country found</p>
      </div>
      <span class="line-border"></span>
      <div class="row countries-scoll">
        <div (click)="setTenant(item?.tenantId)" *ngFor="let item of countriesList"
          class="col-4 text-center mobile-show-countries">
          <img [src]="'../../../../assets/images/flags/'+item?.isoCode.toLowerCase()+'.png'" alt="No Image"
            class="country-flag" />
          <p class="country-name">{{ item?.name }}</p>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>